import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from '../components/layout/layout.component';
import { CallingScreenComponent } from './calling-screen/calling-screen.component';
import { CallingScreenBetaComponent } from './calling-screen-beta';

const routes: Routes = [
    {
        path: '', component: LayoutComponent,
        children: [
            {
                path: 'calling-screen',
                component: CallingScreenComponent
            },
            {
                path: 'calling-screen-beta',
                component: CallingScreenBetaComponent
            }
        ]
    }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class CallingScreenRoutingModule { }